import React, { useState } from "react";

export default function SakshamShaktiImpact() {
  const [activeTab, setActiveTab] = useState("shakti");

  const shaktiData = [
  {
    name: "Rani Jadhav",
    district: "Solapur",
    activity: "Handloom Revival Entrepreneur",
    impact:
      "Revived local handloom weaving by digitizing her SHG’s operations through Think5Whys. Increased production efficiency by 60% and expanded to 3 new villages.",
    img: "https://via.placeholder.com/200x200/FF69B4/000000?text=Rani",
    badge: "🧵 Textile Innovator",
    platformUse:
      "Used Think5Whys Inventory & Digital Training modules to modernize her weaving cooperative.",
  },
  {
    name: "Kavita Mane",
    district: "Pune",
    activity: "Homemade Snackpreneur",
    impact:
      "Started a digital food brand with Think5Whys guidance; achieved ₹75,000 monthly sales of traditional snacks through online and SHG networks.",
    img: "https://via.placeholder.com/200x200/FF85A2/000000?text=Kavita",
    badge: "🍪 Local Food Star",
    platformUse:
      "Utilized Think5Whys Product Listing & Digital Card for customer reach.",
  },
  {
    name: "Meena Gaikwad",
    district: "Wardha",
    activity: "Digital Literacy Facilitator",
    impact:
      "Trained 120 rural women in basic digital skills, helping them access government schemes and Think5Whys ValueShare opportunities.",
    img: "https://via.placeholder.com/200x200/FDAEAE/000000?text=Meena",
    badge: "💻 Digital Didi",
    platformUse:
      "Conducted workshops using Think5Whys Learning & Self-Reflection tools.",
  },
  {
    name: "Priyanka Patil",
    district: "Kolhapur",
    activity: "Agro-Processing Entrepreneur",
    impact:
      "Set up a turmeric and jaggery unit under SHG network; used Think5Whys to connect with wholesale buyers across Maharashtra.",
    img: "https://via.placeholder.com/200x200/FF99BB/000000?text=Priyanka",
    badge: "🌾 Agro Shakti",
    platformUse:
      "Leveraged MSME Module & MahilaMandi Supply Chain Dashboard.",
  },
  {
    name: "Sneha Kulkarni",
    district: "Nagpur",
    activity: "Waste-to-Art Innovator",
    impact:
      "Turned plastic waste into decorative home items. Her digital showcase on Think5Whys inspired 10+ local SHGs to adopt recycling ideas.",
    img: "https://via.placeholder.com/200x200/F48FB1/000000?text=Sneha",
    badge: "♻️ Eco Creator",
    platformUse:
      "Used Think5Whys Artisan & Sustainability Campaign tools.",
  },
];


  const groupData = [
  {
    name: "Gaurav Mahila Bachat Gat",
    district: "Kolhapur",
    members: 25,
    impact:
      "Used Think5Whys to digitize their daily savings and lending records; reduced errors and increased transparency.",
    img: "https://via.placeholder.com/200x200/FF80AA/000000?text=Gaurav+Gat",
    badge: "📊 Digital Record Keeper",
    platformUse: "Used Think5Whys MSME & Payment Reminder tools.",
  },
  {
    name: "Savitribai Women Collective",
    district: "Nagpur",
    members: 40,
    impact:
      "Developed a handicraft brand using platform's product catalog & AI-based pricing system; gained ₹50,000/month revenue growth.",
    img: "https://via.placeholder.com/200x200/FFB6C1/000000?text=Savitribai+Gat",
    badge: "🎨 Artisan Excellence",
    platformUse:
      "Used Think5Whys Product Management & Digital Promotion modules.",
  },
  {
    name: "Swayam Shakti Gat",
    district: "Nashik",
    members: 32,
    impact:
      "Collaboratively launched an organic food products brand after attending Think5Whys digital marketing bootcamp; now supplies to 10+ local stores.",
    img: "https://via.placeholder.com/200x200/FF99BB/000000?text=Swayam+Gat",
    badge: "🌿 Organic Achiever",
    platformUse:
      "Used Think5Whys Training, MahilaMandi Marketplace & Rozgar Hami linkages.",
  },
];


  const activeList = activeTab === "shakti" ? shaktiData : groupData;

  return (
    <div className="min-h-screen bg-gray-900 text-pink-200 flex flex-col items-center p-4">
      {/* Header */}
      <header className="text-center mb-6">
        <h1 className="text-3xl font-bold text-pink-400 mb-1">
          🌸 Saksham Shakti Impact
        </h1>
        <p className="text-sm text-pink-300">
          Celebrating Impact Makers of the Think5Whys Platform
        </p>
      </header>

      {/* Tabs */}
      <div className="flex justify-center gap-3 mb-6">
        <button
          onClick={() => setActiveTab("shakti")}
          className={`px-5 py-2 rounded-full font-semibold text-sm transition-all ${
            activeTab === "shakti"
              ? "bg-pink-600 text-white shadow-lg"
              : "bg-gray-800 text-pink-400 hover:bg-pink-700 hover:text-white"
          }`}
        >
          <i className="fa-solid fa-user mr-2"></i>Shakti
        </button>
        <button
          onClick={() => setActiveTab("group")}
          className={`px-5 py-2 rounded-full font-semibold text-sm transition-all ${
            activeTab === "group"
              ? "bg-pink-600 text-white shadow-lg"
              : "bg-gray-800 text-pink-400 hover:bg-pink-700 hover:text-white"
          }`}
        >
          <i className="fa-solid fa-users mr-2"></i>Group
        </button>
      </div>

      {/* Card Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 w-full max-w-6xl">
        {activeList.map((item, idx) => (
          <div
            key={idx}
            className="bg-gray-800 border border-pink-600 rounded-2xl p-5 shadow-lg hover:shadow-pink-400/40 transition-all duration-300 flex flex-col items-center"
          >
            <img
              src={item.img}
              alt={item.name}
              className="w-28 h-28 object-cover rounded-full border-4 border-pink-500 mb-3"
            />

            <h2 className="text-xl font-semibold text-pink-300">{item.name}</h2>
            <p className="text-sm text-gray-300 flex items-center justify-center gap-1">
              <i className="fa-solid fa-location-dot text-pink-400"></i>{" "}
              {item.district}
            </p>

            <span className="mt-1 text-xs bg-pink-700 text-white px-3 py-1 rounded-full shadow-md">
              {item.badge}
            </span>

            {activeTab === "group" && (
              <p className="text-xs mt-1 text-gray-400">
                👩‍👩‍👧‍👦 {item.members} Members
              </p>
            )}

            <p className="text-sm mt-3 text-gray-300 text-center">
              {item.impact}
            </p>

            <p className="text-xs mt-2 text-gray-400 text-center italic">
              <i className="fa-solid fa-lightbulb text-pink-400 mr-1"></i>
              {item.platformUse}
            </p>
          </div>
        ))}
      </div>

      {/* Footer */}
      <footer className="mt-8 text-center text-xs text-pink-400 opacity-70">
        © 2025 Think5Whys | Empowering Women and SHGs across Maharashtra
      </footer>
    </div>
  );
}
